import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-unconventional-charter-solution',
    templateUrl: './unconventional-charter-solution.component.html',
    styleUrls: ['./unconventional-charter-solution.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnconventionalCharterSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
